import apiClient from './api-client';

export default {
  getSettings() {
    return apiClient.get('/whatsapp-settings');
  },

  updateSettings(data) {
    return apiClient.patch('/whatsapp-settings', data);
  },

  sendTest(phone) {
    return apiClient.post('/whatsapp-settings/test', { phone });
  },
};
